import { JoinPageLayout } from "./JoinPageLayout";

export function EnglishJoinPage() {
  return (
    <JoinPageLayout
      eyebrow="WORK BETWEEN MOUNTAIN & SEA"
      title="Come stay with us."
      subtitle="DULAN STAR GUEST HOUSE"
    >
      <p>
        Dulan Star is more than a place to sleep. We want it to be a space where
        people can slow down, connect and feel at ease. Working here means
        caring for the environment and offering every guest genuine hospitality.
      </p>
      <h2>What we offer</h2>
      <p>
        A friendly workplace, hands-on hospitality experience and the chance to
        live close to Dulan’s nature and community.
      </p>
      <h2>Current openings</h2>
      {/* <h3>Part-time Cleaning Staff</h3>
      <p>NT$200 per hour, 11:00–13:00, two or three days each week.</p> */}
      <h3>Work for Stay</h3>
      <p>Around 4 hours per day, 2 dayoff a week, for a minimum of three weeks.</p>
      <div className="join-actions">
        <a className="outline-dark" href="/application">
          JOB APPLICATION
        </a>
        <a className="outline-dark" href="/workforstay">
          WORK FOR STAY
        </a>
        <a className="text-link" href="/joinus">
          中文版 →
        </a>
      </div>
    </JoinPageLayout>
  );
}
